export const FIELDS_TO_STORE_DEPENDENCIES = ['CustomerName', 'OfficeName', 'ProjectName'];

export const DEPENDENCY_ORDERS = {
  OfficeName: ['CustomerName'],
  ProjectName: ['OfficeName', 'CustomerName'],
  UnitName: ['ProjectName', 'OfficeName', 'CustomerName'],
};

export const DEPENDENCY_API_PARAM_KEY = {
  CustomerName: 'customerId',
  OfficeName: 'officeId',
  ProjectName: 'projectId',
};
